import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaSearch, FaCog, FaBell } from 'react-icons/fa';
import profileImg from '../assets/profile.svg';

const avatarConfig = [
  {
    title: 'Search',
    path: '#search',
  },
  {
    title: 'Setting',
    path: '#setting',
  },
  {
    title: 'Notification',
    path: '#notification',
  },
];

const Navbar = ({ toggleSidebar }) => {
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();

  const routeTitles = {
    '/dashboard': 'Dashboard',
    '/employee': 'Employee Directory',
    '/ride-history': 'Ride History',
    '/book-ride': 'Book a Ride',
    '/promotion': 'Promotions & Coupon',
    '/profile': 'Profile',
  };

  const currentTitle = routeTitles[location.pathname] || 'Dashboard';

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const toggleSearch = () => {
    setIsSearchActive(!isSearchActive);
  };

  return (
    <nav className='navbar d-flex align-items-center justify-content-between px-3'>
      <div className='d-flex align-items-center'>
        <button
          className='btn btn-light d-lg-none me-2 sidebar-toggle'
          style={{ padding: '8px', marginLeft: '0px' }}
          onClick={toggleSidebar}
        >
          ☰
        </button>
        <h1 className='navbar-title m-0 fw-bold'>{currentTitle}</h1>
      </div>

      {/* Search Bar and Icons */}
      <div className='d-flex align-items-center'>
        {/* Search Container */}
        <div
          className={`search-tab search-container d-flex align-items-center me-4`}
        >
          <FaSearch
            className='search-icon d-flex align-items-center'
            style={{ cursor: 'pointer', color: '#969696' }}
            onClick={toggleSearch}
          />
          <input
            type='text'
            placeholder='Search for something'
            className='form-control search-input'
          />
        </div>

        {/* Settings and Notification Icons */}
        <div className='d-flex align-items-center ms-3'>
          <button
            className='btn rounded-circle d-none d-lg-inline-block me-4'
            style={{ width: '50px', height: '50px', background: '#f5f7fa' }}
          >
            <FaCog style={{ color: '#969696' }} size={25} />
          </button>
          <button
            className='btn rounded-circle d-none d-lg-inline-block me-4'
            style={{ width: '50px', height: '50px', background: '#f5f7fa' }}
          >
            <FaBell style={{ color: '#f37a20' }} size={25} />
          </button>

          {/* Avatar Dropdown */}
          <div
            className={`dropdown ${isDropdownOpen ? 'show' : ''}`}
            onClick={toggleDropdown}
          >
            <img
              src={profileImg}
              alt='Profile'
              className='rounded-circle profile-img'
              style={{ width: '50px', height: '50px', cursor: 'pointer' }}
              data-bs-toggle='dropdown'
            />
            {isDropdownOpen && (
              <div className='dropdown-menu dropdown-menu-end custom-dropdown'>
                {avatarConfig.map((item, index) => (
                  <Link to={item.path} className='dropdown-item' key={index}>
                    {item.title}
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
